import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDateTime, humanize } from '@/lib/format';
import MessageStatusPill from '@/pages/apps/components/message-status-pill';
import { app_invoice_path } from '@/rails/routes';
import type { Message } from '@/types/platform';
import { Link } from '@inertiajs/react';

interface MessageTableProps {
  appId: string;
  messages: Message[];
  showSubject?: boolean;
  // Links each message to the invoice it was about. Off on the invoice's own page.
  showInvoice?: boolean;
}

// The mail log: what was sent, to whom, and what became of it.
const MessageTable = ({
  appId,
  messages,
  showSubject = true,
  showInvoice = true,
}: MessageTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Kind</TableHead>
          <TableHead>To</TableHead>
          {showSubject ? <TableHead>Subject</TableHead> : null}
          <TableHead>Status</TableHead>
          <TableHead>Time</TableHead>
          {showInvoice ? <TableHead>Invoice</TableHead> : null}
        </TableRow>
      </TableHeader>
      <TableBody>
        {messages.map((message) => (
          <TableRow key={message.id}>
            <TableCell>{humanize(message.kind)}</TableCell>
            <TableCell>{message.toAddress}</TableCell>
            {showSubject ? <TableCell>{message.subject}</TableCell> : null}
            <TableCell className="whitespace-normal">
              <MessageStatusPill status={message.status} />
              {message.error ? (
                <p className="mt-1 max-w-xs min-w-40 text-xs text-red-700">{message.error}</p>
              ) : null}
            </TableCell>
            <TableCell className="text-muted-foreground">
              {formatDateTime(message.sentAt ?? message.createdAt)}
            </TableCell>
            {showInvoice ? (
              <TableCell>
                {message.invoiceId ? (
                  <Link
                    href={app_invoice_path(appId, message.invoiceId)}
                    className="font-medium underline"
                  >
                    {message.invoiceNumber ?? 'Draft'}
                  </Link>
                ) : (
                  <span className="text-muted-foreground">—</span>
                )}
              </TableCell>
            ) : null}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MessageTable;
